import React from "react";
import "../App.css";

const PricingPage = () => {
  return (
    <div className="pricing-main">
      <h1 className="section-title">Simple, Honest Pricing</h1>
      <div className="pricing-grid">
        <div className="pricing-card">
          <h2>Starter</h2>
          <p className="price">from $2,500</p>
          <ul>
            <li>Perfect for a landing page or MVP</li>
            <li>Quick turnaround (1–2 weeks)</li>
            <li>Direct email support</li>
          </ul>
          <div style={{ marginTop: 12, fontSize: "0.97rem", color: "#888" }}>
            Great for getting your idea online fast.
          </div>
        </div>
        <div className="pricing-card featured">
          <h2>Business</h2>
          <p className="price">from $7,500</p>
          <ul>
            <li>Custom web/app development</li>
            <li>4–6 weeks, collaborative process</li>
            <li>Priority support & 1 year maintenance</li>
          </ul>
          <div style={{ marginTop: 12, fontSize: "0.97rem", color: "#888" }}>
            Our most popular option for growing teams and businesses.
          </div>
        </div>
        <div className="pricing-card">
          <h2>Enterprise</h2>
          <p className="price">Let's chat</p>
          <ul>
            <li>Big ideas, big builds</li>
            <li>Dedicated team & project manager</li>
            <li>Custom integrations, ongoing partnership</li>
          </ul>
          <div style={{ marginTop: 12, fontSize: "0.97rem", color: "#888" }}>
            We’ll tailor a plan just for you.
          </div>
        </div>
      </div>
      <div className="pricing-note" style={{ marginTop: 40 }}>
        Not sure where you fit? <b>Let’s talk.</b> We’ll give you a free,
        no-pressure consultation and a clear quote, with no surprises.
      </div>
    </div>
  );
};

export default PricingPage;
